import {ThunkActionCreator} from "../interfaces/thunk";
import {Dispatch} from "../interfaces/dispatch";
import axios from "axios";
import Config from "../config";
import {getHeaders} from "../helpers/headers";
import ProductDistribution from "../components/reports/ProductDistribution";
import {AnyAction} from "../interfaces/action";
import {
  FETCH_SEGMENTATION_REPORT, FETCH_SEGMENTATION_REPORT_FAILED,
  FETCH_SEGMENTATION_REPORT_REQUEST,
  SegmentationReportState
} from "./segmentation-report";
import {handleActions} from "redux-actions";

// AbortController for cancelling previous requests to prevent race conditions
let productDistributionController: AbortController | null = null;
let productDistributionComparisonController: AbortController | null = null;

function getCancelableProductDistributionAxios() {
  if (productDistributionController) {
    productDistributionController.abort();
  }
  productDistributionController = new AbortController();
  return { signal: productDistributionController.signal };
}

function getCancelableComparisonAxios() {
  if (productDistributionComparisonController) {
    productDistributionComparisonController.abort();
  }
  productDistributionComparisonController = new AbortController();
  return { signal: productDistributionComparisonController.signal };
}



export const FETCH_FILTER_INFO_REQUEST = "FETCH_FILTER_INFO_REQUEST"
export const FETCH_FILTER_INFO = "FETCH_FILTER_INFO"
export const FETCH_FILTER_INFO_FAILED = "FETCH_FILTER_INFO_FAILED"
export const FETCH_PRODUCT_DISTRIBUTION_REQUEST = "FETCH_PRODUCT_DISTRIBUTION_REQUEST";
export const FETCH_PRODUCT_DISTRIBUTION = "FETCH_PRODUCT_DISTRIBUTION";
export const FETCH_PRODUCT_DISTRIBUTION_FAILED = "FETCH_PRODUCT_DISTRIBUTION_FAILED";

export const FETCH_PRODUCT_DISTRIBUTION_COMPARISON_REQUEST = "FETCH_PRODUCT_DISTRIBUTION_COMPARISON_REQUEST";
export const FETCH_PRODUCT_DISTRIBUTION_COMPARISON = "FETCH_PRODUCT_DISTRIBUTION_COMPARISON";
export const FETCH_PRODUCT_DISTRIBUTION_COMPARISON_FAILED = "FETCH_PRODUCT_DISTRIBUTION_COMPARISON_FAILED";

const fetchProductDistributionFilters: ThunkActionCreator<Promise<void>> = (id: number, type: string, value?: string) => (dispatch: Dispatch) => {
  dispatch({ type: FETCH_FILTER_INFO_REQUEST });
  let url=""
  if(value){
    url= `${Config.API_SERVICE_URL}/api/reports/productDistribution/dropdowns/${id}/${type}/${value}`
  }else{
    url= `${Config.API_SERVICE_URL}/api/reports/productDistribution/dropdowns/${id}/${type}/${undefined}`
  }
  return axios
    .get(url, getHeaders())
    .then((response) => {
      dispatch({ type: FETCH_FILTER_INFO, payload: response.data });
    })
    .catch((_) => {
      dispatch({ type: FETCH_FILTER_INFO_FAILED });
    });
}

const fetchProductDistributionInfo: ThunkActionCreator<Promise<void>> = (id: number, filters?: { brand?: string; packageGroup?: string; subCategory?: string },
  pagination?: { page?: number; size?: number; sort?: string; search?: Record<string, string> },storeIds?:[],comparisinProject?:number) => (dispatch: Dispatch) => {
  const { signal } = getCancelableProductDistributionAxios();
  // Dispatch appropriate request action based on whether it's a comparison
  if (comparisinProject && comparisinProject > -1) {
    dispatch({ type: FETCH_PRODUCT_DISTRIBUTION_COMPARISON_REQUEST });
  } else {
    dispatch({ type: FETCH_PRODUCT_DISTRIBUTION_REQUEST });
  }
  // const params = new URLSearchParams();
  //   const page= pagination?.page || 0
  //     const size= pagination?.size || 100
  // const sort= pagination?.sort || 'product_nm.desc'
  //   // const name= pagination?.searchTerm || ''
  //
  // if (storeIds && storeIds.length > 0) {
  //   params.set("storeIds", storeIds.join(","));
  // }
  //
  // if (filters?.brand) {
  //   params.set("brand", filters.brand);
  // }
  // if (filters?.packageGroup) {
  //   params.set("packageGroup", filters.packageGroup);
  // }
  // if (filters?.subCategory) {
  //   params.set("subCategory", filters.subCategory);
  // }
  // if (pagination?.page) {
  //   params.set("page",pagination.page.toString() )
  // }
  // if (pagination?.size) {
  //   params.set("size",pagination.size.toString() )
  //
  // }
  // if (pagination?.sort) {
  //   params.set("sort",pagination.sort )
  // }
  //
  // if(comparisinProject && comparisinProject>-1){
  //   params.set("comparisonProject",comparisinProject.toString())
  // }

  let body:any = {
    "projectId":id,
    "storeIds":storeIds?storeIds.join(","):[],
    "brand":filters?.brand?filters.brand:[],
    "packageGroup": filters?.packageGroup?filters.packageGroup:[],
    "subCategory":filters?.subCategory?filters.subCategory:[],
    "page":pagination?pagination?.page?pagination?.page.toString():"":0,
    "size":pagination?pagination?.size?pagination?.size.toString():"":100,
    "sort":pagination?.sort?pagination?.sort:"",
    "comparisonProject":comparisinProject?comparisinProject.toString():""
  }

  if (pagination?.search) {
    const fieldMapping: Record<string, string> = {
      product_nm: "name",

    };

    Object.entries(pagination.search).forEach(([key, value]) => {
      if (value) {
        const mappedKey = fieldMapping[key] || key;
        body[mappedKey] = value;
      }
    });
  }

  return axios
    .post(`${Config.API_SERVICE_URL}/api/reports/productDistribution`,body, { ...getHeaders(), signal })
    .then((response) => {
      // Dispatch to comparison data if comparisonProject is provided
      if (comparisinProject && comparisinProject > -1) {
        dispatch({ type: FETCH_PRODUCT_DISTRIBUTION_COMPARISON, payload: response.data });
      } else {
      dispatch({ type: FETCH_PRODUCT_DISTRIBUTION, payload: response.data });
      }
    })
    .catch((err) => {
      if (err.name === "CanceledError") {
        console.log("Previous product distribution request cancelled");
      } else if (comparisinProject && comparisinProject > -1) {
        dispatch({ type: FETCH_PRODUCT_DISTRIBUTION_COMPARISON_FAILED });
      } else {
      dispatch({ type: FETCH_PRODUCT_DISTRIBUTION_FAILED });
      }
    });
}

const fetchProductDistributionComparison: ThunkActionCreator<Promise<void>> =
  (
    baseProjectId: number,
    comparisonProjectId: number,
    storeIds: number[] = [],
    filters?: { brand?: string; packageGroup?: string; subCategory?: string }
  ) => (dispatch: Dispatch) => {
    const { signal } = getCancelableComparisonAxios();

    dispatch({ type: FETCH_PRODUCT_DISTRIBUTION_COMPARISON_REQUEST });

    const params: any = {
      baseProjectId,
      comparisonProjectId,
    };

    if (storeIds.length > 0) {
      params.storeIds = storeIds.join(",");
    }
    const formatParam = (val?: string | string[]) => {
      if (!val) return undefined;
      return Array.isArray(val) ? val.join(",") : val;
    };

    if (filters?.brand) {
      params.brand = formatParam(filters.brand);
    }
    if (filters?.packageGroup) {
      params.packageGroup = formatParam(filters.packageGroup);
    }
    if (filters?.subCategory) {
      params.subCategory = formatParam(filters.subCategory);
    }

    return axios.get(
      `${Config.API_SERVICE_URL}/api/reports/productDistributionComparison`,
      {
        ...getHeaders(),
        params,
        signal,
      }
    )
      .then((response) => {
        dispatch({
          type: FETCH_PRODUCT_DISTRIBUTION_COMPARISON,
          payload: response.data
        });
      })
      .catch((err) => {
        if (err.name === "CanceledError") {
          console.log("Previous product distribution comparison request cancelled");
        } else {
        console.error("Product Distribution comparison API error:", err);
        dispatch({ type: FETCH_PRODUCT_DISTRIBUTION_COMPARISON_FAILED });
        }
      });
  };

const actions = {
  [FETCH_FILTER_INFO_REQUEST]: (state: ProductDistributionState) => ({
    ...state,
    loading: true,
  }),
  [FETCH_FILTER_INFO]: (state: ProductDistributionState, action: AnyAction): ProductDistributionState => ({
    ...state,
    loading: false,
    filters: {
      ...state.filters,
      ...action.payload,
    },
  }),
  [FETCH_FILTER_INFO_FAILED]: (state: ProductDistributionState) => ({
    ...state,
    loading: false,
    error: true,
    filters: state.filters,
  }),
  [FETCH_PRODUCT_DISTRIBUTION_REQUEST]: (state: ProductDistributionState) => ({
    ...state,
    loading: true,
    content: {},
  }),
  [FETCH_PRODUCT_DISTRIBUTION]: (state: ProductDistributionState, action: AnyAction): ProductDistributionState => ({
    ...state,
    loading: false,
    content: {...action.payload} ,
  }),
   [FETCH_PRODUCT_DISTRIBUTION_FAILED]: (state: ProductDistributionState) => ({
    ...state,
    loading: false,
    error: true,
    content: undefined,
  }),

  [FETCH_PRODUCT_DISTRIBUTION_COMPARISON_REQUEST]: (state: ProductDistributionState) => ({
    ...state,
    loading: true,
    comparisonData: {},
  }),
  [FETCH_PRODUCT_DISTRIBUTION_COMPARISON]: (state: ProductDistributionState, action: AnyAction): ProductDistributionState => ({
    ...state,
    loading: false,
    comparisonData: { ...action.payload },
  }),
  [FETCH_PRODUCT_DISTRIBUTION_COMPARISON_FAILED]: (state: ProductDistributionState) => ({
    ...state,
    loading: false,
    error: true,
    comparisonData: {},
  }),

}


export interface ProductDistributionState {
  content: any;
  error: boolean;
  loading: boolean;
  filters:any
  comparisonData:any
}

const initialState: ProductDistributionState = {
  loading: false,
  error: false,
  content: {},
  filters:{},
  comparisonData:{}
};



export {fetchProductDistributionInfo,fetchProductDistributionFilters, fetchProductDistributionComparison }

export default handleActions<ProductDistributionState, AnyAction>(actions, initialState);
